export default __webpack_public_path__ + "static/media/GT-Ultra-Standard-Ultra.10f61d5e.woff";